import { useState, useEffect } from "react";
import emailjs from "emailjs-com";
import { Helmet } from "react-helmet";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";

export const ContactUs = () => {
  useEffect(() => {
    AOS.init({
      duration: 900,
      easing: "ease-out-cubic",
      once: true,
    });
  }, []);

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    contact: "",
    suggestion: "",
  });

  const [message, setMessage] = useState("");
  const [isSending, setIsSending] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSending(true);
    setMessage("");

    emailjs
      .send(
        "service_0ocl21v", // service ID
        "template_h1xce97", // template ID
        formData,
        "pWankTzGgMZWNx1hi" // public key
      )
      .then(
        () => {
          setMessage("Thank you — your message has been sent.");
          setFormData({
            fullName: "",
            email: "",
            contact: "",
            suggestion: "",
          });
          setIsSending(false);
        },
        () => {
          setMessage("Something went wrong. Please try again later.");
          setIsSending(false);
        }
      );
  };

  return (
    <>
      <Helmet>
        <title>Contact | Biblivium</title>
        <meta
          name="description"
          content="Get in touch with Biblivium. We welcome questions, ideas, and thoughtful conversations."
        />
      </Helmet>

      <main className="py-5" style={{ fontFamily: "Inter, system-ui, sans-serif" }}>
        <div className="container">
          <div className="card shadow border-0 overflow-hidden" data-aos="fade-up">
            <div className="row g-0">
              {/* Image column: hidden on mobile */}
              <div className="col-md-6 d-none d-md-block position-relative">
                <img
                  src="/media/hero.jpg"
                  alt="A quiet space for reading and reflection"
                  className="img-fluid w-100 h-100"
                  style={{ objectFit: "cover", minHeight: "560px" }}
                />
                <div
                  className="position-absolute text-white p-3"
                  style={{
                    bottom: "28px",
                    left: "28px",
                    background: "rgba(0,0,0,0.45)",
                    borderRadius: "6px",
                    maxWidth: "80%",
                    lineHeight: 1.4,
                  }}
                >
                  “Every meaningful conversation begins with a question.”
                </div>
              </div>

              {/* Form column */}
              <div className="col-12 col-md-6 p-4 p-md-5 d-flex flex-column justify-content-center">
                <h1 className="mb-3" style={{ fontSize: "2.4rem", fontWeight: 700 }}>
                  Contact
                </h1>
                <p className="mb-4" style={{ color: "#6b6b6b", fontSize: "1.05rem", lineHeight: 1.6 }}>
                  We welcome questions, ideas, and thoughtful conversations. Reach out. We read every message.
                </p>

                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label fw-medium">Full Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="fullName"
                      required
                      value={formData.fullName}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-medium">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      required
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-medium">Contact Number</label>
                    <input
                      type="tel"
                      className="form-control"
                      name="contact"
                      required
                      value={formData.contact}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-medium">Message</label>
                    <textarea
                      className="form-control"
                      name="suggestion"
                      required
                      value={formData.suggestion}
                      onChange={handleChange}
                      style={{ minHeight: "120px" }}
                    />
                  </div>

                  <div className="mb-3 form-check">
                    <input type="checkbox" className="form-check-input" required />
                    <label className="form-check-label">
                      I agree to the{" "}
                      <a
                        href="/privacy-policy"
                        style={{ color: "#1c1c1c", textDecoration: "underline" }}
                      >
                        Privacy Policy
                      </a>
                    </label>
                  </div>

                  <button
                    type="submit"
                    className="btn btn-dark w-100"
                    disabled={isSending}
                  >
                    {isSending ? "Sending…" : "Send Message"}
                  </button>
                </form>

                {message && (
                  <p className="mt-3 text-secondary">{message}</p>
                )}

                <p className="mt-4 text-secondary" style={{ fontSize: "0.95rem" }}>
                  Or write to us directly at <br />
                  <a href="mailto:info@lonewolfwrites.com" style={{ color: "#1c1c1c", textDecoration: "underline" }}>info@lonewolfwrites.com</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};
